/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetForecastModelResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetForecastModelResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/models/{modelId}
 */
export interface WithModelItemRequestBuilder extends BaseRequestBuilder<WithModelItemRequestBuilder> {
    /**
     * Returns one trained model's metadata: the date range it was trained on, how many data points it saw, its accuracy metrics, and whether it is the current model — the one a forecast uses when the caller pins no modelId. Metadata only; this does not produce a forecast. Use GET /api/forecasting/models to find a modelId. Models belong to the caller's organization, so a modelId from another organization reads as not found.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetForecastModelResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetForecastModelResponse | undefined>;
    /**
     * Returns one trained model's metadata: the date range it was trained on, how many data points it saw, its accuracy metrics, and whether it is the current model — the one a forecast uses when the caller pins no modelId. Metadata only; this does not produce a forecast. Use GET /api/forecasting/models to find a modelId. Models belong to the caller's organization, so a modelId from another organization reads as not found.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithModelItemRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/models/{modelId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithModelItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithModelItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetForecastModelResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
